import { DomainError } from '@dma/shared';

export class InvalidArticleError extends DomainError {
  constructor(reason: string) {
    super('INVALID_ARTICLE', `Article is invalid: ${reason}`);
    this.name = 'InvalidArticleError';
    Object.setPrototypeOf(this, InvalidArticleError.prototype);
  }
}
